module.exports = "/_next/static/images/bg-blue-seat-57a0ea60.png";